import { PageViewEventName } from "@/types/event-types";
import { useRouterState } from "@tanstack/react-router";

export const DEFAULT_PAGE_TITLE = "Salt Dash";
const DEFAULT_TRACK_EVENT_NAME = "dash_page_viewed";

type StaticData =
  | {
      title?: string;
      eventName?: PageViewEventName;
    }
  | undefined;

export const useRouterPageTitle = () => {
  const matches = useRouterState({ select: (state) => state.matches });

  return (
    [...matches]
      .reverse()
      .map((match) => (match.staticData as StaticData)?.title)
      .find(
        (value): value is string =>
          typeof value === "string" && value.length > 0,
      ) ?? DEFAULT_PAGE_TITLE
  );
};

export const useRouterTrackEventName = (): PageViewEventName => {
  const matches = useRouterState({ select: (state) => state.matches });

  return (
    [...matches]
      .reverse()
      .map((match) => (match.staticData as StaticData)?.eventName)
      .find(
        (value): value is PageViewEventName =>
          typeof value === "string" && value.length > 0,
      ) ?? DEFAULT_TRACK_EVENT_NAME
  );
};
